export const getScreenSize = () => {
    const width = window.innerWidth;
    if (width <= 480) return "xs";
    if (width <= 768) return "sm";
    if (width <= 1024) return "md";
    if (width <= 1366) return "lg";
    if (width <= 1920) return "xl";
    return "xxl";
};

export const getResponsiveSpacing = (screenSize) => {
    const spacingMap = {
        xs: { padding: "0.5rem", margin: "0.25rem", gap: "0.5rem" },
        sm: { padding: "0.75rem", margin: "0.5rem", gap: "0.75rem" },
        md: { padding: "1rem", margin: "0.75rem", gap: "1rem" },
        lg: { padding: "1.25rem", margin: "1rem", gap: "1.25rem" },
        xl: { padding: "1.5rem", margin: "1.25rem", gap: "1.5rem" },
        xxl: { padding: "2rem", margin: "1.5rem", gap: "2rem" },
    };
    return spacingMap[screenSize] || spacingMap.lg;
};

export const getResponsiveFontSizes = (screenSize) => {
    const fontMap = {
        xs: { title: "1.25rem", subtitle: "0.875rem", body: "0.75rem", small: "0.6875rem" },
        sm: { title: "1.5rem", subtitle: "1rem", body: "0.875rem", small: "0.75rem" },
        md: { title: "1.75rem", subtitle: "1.125rem", body: "0.9375rem", small: "0.8125rem" },
        lg: { title: "2rem", subtitle: "1.25rem", body: "1rem", small: "0.875rem" },
        xl: { title: "2.25rem", subtitle: "1.375rem", body: "1rem", small: "0.875rem" },
        xxl: { title: "2.5rem", subtitle: "1.5rem", body: "1.125rem", small: "1rem" },
    };
    return fontMap[screenSize] || fontMap.lg;
};